<mat-form-field [class]="class">
    <mat-label>{{ labelKey | translate }}</mat-label>
    <mat-select [(ngModel)]="value" [required]="required">
        @if (!required) {
            <mat-option [value]="undefined">-</mat-option>
        }
        @for (placeholder of RelativeDatePlaceholders | keyvalue; track placeholder.key) {
            <mat-option [value]="placeholder.value">
                {{ 'RelativeDateInput.' + placeholder.key | translate }}
            </mat-option>
        }
    </mat-select>
</mat-form-field>
